@if(navbar.userAccess?.Appointments=='Full'){
<div class="row g-1">
	@if (mailList.length) {
	<div class="col-3">
		@for (mail of mailList; track $index) {
		<app-mail-display [mail]="mail" [showTrail]="false"></app-mail-display>
		}
	</div>
	}
	<div [ngClass]="mailList.length?'col-9':'col-12'">
		<div class="card">
			<div class="card-header bg-white py-3 d-flex justify-content-between align-items-center">
				<h5 class="card-title mb-0 fw-bold">
					{{ pagetitle }}
				</h5>
				<button *ngIf="!uId" class="btn btn-sm btn-outline-primary shadow-sm d-flex align-items-center gap-1"
					(click)="openCaseIdModal()">
					<fa-icon [icon]="['fas', 'link']"></fa-icon>
					Link To HC
				</button>
			</div>
			<div class="card-body p-4">
				<form [formGroup]="moduleForm" (ngSubmit)="saveData()" #modform="ngForm">
					<div class="form-section mb-4">
						<h6 class="text-uppercase fs-7 fw-bold text-muted mb-3 border-bottom pb-2">
							Basic & Personal Details
						</h6>
						<div class="row g-3">
							<div class="col-lg-3 col-md-4 col-sm-6">
								<div class="input-group">
									<div class="form-floating flex-grow-1">
										<input class="form-control" [ngClass]="{'is-invalid': showError('start_date')}"
											placeholder="Start Date" formControlName="start_date" ngbDatepicker
											id="start_date" #start_date="ngbDatepicker" [minDate]="minStartDate"
											[container]="'body'" />
										<label for="start_date">Start Date*</label>
									</div>
									<button class="btn btn-outline-secondary" (click)="start_date.toggle()"
										type="button">
										<fa-icon [icon]="['fas', 'calendar-week']"></fa-icon>
									</button>
								</div>
								<div *ngIf="showError('start_date')" class="invalid-feedback d-block">
									<span *ngIf="f.start_date.errors?.required">Required</span>
									<span *ngIf="f.start_date.errors?.ngbDate">Invalid date</span>
									<span *ngIf="f.start_date.errors?.incorrect">{{ customError.start_date }}</span>
								</div>
							</div>
							<div class="col-lg-3 col-md-4 col-sm-6">
								<div class="input-group">
									<div class="form-floating flex-grow-1">
										<input class="form-control" [ngClass]="{'is-invalid': showError('dob')}"
											placeholder="Date of Birth" formControlName="dob" ngbDatepicker id="dob"
											#dob="ngbDatepicker" [minDate]="minDate" [maxDate]="maxDate"
											[container]="'body'" (ngModelChange)="calculateAge()" />
										<label for="dob">Date of Birth</label>
									</div>
									<button class="btn btn-outline-secondary" (click)="dob.toggle()" type="button">
										<fa-icon [icon]="['fas', 'calendar-week']"></fa-icon>
									</button>
								</div>
								<div *ngIf="showError('dob')" class="invalid-feedback d-block">
									<span *ngIf="f.dob.errors?.required">Required</span>
									<span *ngIf="f.dob.errors?.ngbDate">Invalid date</span>
									<span *ngIf="f.dob.errors?.incorrect">{{ customError.dob }}</span>
								</div>
							</div>
							<div class="col-lg-2 col-md-4 col-sm-6">
								<div class="form-floating">
									<input class="form-control bg-light" id="age" [value]="f.age.value" readonly
										placeholder="Age">
									<label for="age">Age</label>
								</div>
							</div>
							<div class="col-lg-4 col-md-6 col-sm-6 d-flex flex-column justify-content-center">
								<label class="form-label text-muted fs-7 mb-1">Gender*</label>
								<mat-radio-group aria-label="Select Gender" formControlName="gender"
									class="d-flex gap-3 align-items-center pt-1">
									<mat-radio-button name="gender" ngDefaultControl value="Male"
										color="primary">Male</mat-radio-button>
									<mat-radio-button name="gender" ngDefaultControl value="Female"
										color="primary">Female</mat-radio-button>
								</mat-radio-group>
								<div *ngIf="showError('gender')" class="invalid-feedback d-block">
									<span *ngIf="f.gender.errors?.required">Required</span>
								</div>
							</div>
						</div>
						<div class="row g-3 mt-1">
							<div class="col-md-4 col-sm-12">
								<div class="form-floating">
									<input class="form-control" [ngClass]="{'is-invalid': showError('f_name')}"
										id="f_name" formControlName="f_name" placeholder="First Name">
									<label for="f_name">First Name*</label>
								</div>
								<div *ngIf="showError('f_name')" class="invalid-feedback d-block">
									<span *ngIf="f.f_name.errors?.required">Required</span>
									<span *ngIf="f.f_name.errors?.incorrect">{{ customError.f_name }}</span>
								</div>
							</div>
							<div class="col-md-4 col-sm-12">
								<div class="form-floating">
									<input class="form-control" [ngClass]="{'is-invalid': showError('m_name')}"
										id="m_name" formControlName="m_name" placeholder="Middle Name">
									<label for="m_name">Middle Name</label>
								</div>
								<div *ngIf="showError('m_name')" class="invalid-feedback d-block">
									<span *ngIf="f.m_name.errors?.incorrect">{{ customError.m_name }}</span>
								</div>
							</div>
							<div class="col-md-4 col-sm-12">
								<div class="form-floating">
									<input class="form-control" [ngClass]="{'is-invalid': showError('l_name')}"
										id="l_name" formControlName="l_name" placeholder="Last Name">
									<label for="l_name">Last Name*</label>
								</div>
								<div *ngIf="showError('l_name')" class="invalid-feedback d-block">
									<span *ngIf="f.l_name.errors?.required">Required</span>
									<span *ngIf="f.l_name.errors?.incorrect">{{ customError.l_name }}</span>
								</div>
							</div>
						</div>
					</div>
					<div class="form-section mb-4">
						<h6 class="text-uppercase fs-7 fw-bold text-muted mb-3 border-bottom pb-2">
							Contact Details
						</h6>
						<div class="row g-3">
							<div class="col-md-6 col-sm-12">
								<div class="form-floating">
									<input class="form-control" [ngClass]="{'is-invalid': showError('address')}"
										id="address" formControlName="address" placeholder="Address">
									<label for="address">Address</label>
								</div>
								<div *ngIf="showError('address')" class="invalid-feedback d-block">
									<span *ngIf="f.address.errors?.required">Required</span>
									<span *ngIf="f.address.errors?.incorrect">{{ customError.address }}</span>
								</div>
							</div>
							<div class="col-md-6 col-sm-12">
								<div class="form-floating">
									<input class="form-control" [ngClass]="{'is-invalid': showError('email')}"
										id="email" formControlName="email" placeholder="Email">
									<label for="email">Email</label>
								</div>
								<div *ngIf="showError('email')" class="invalid-feedback d-block">
									<span *ngIf="f.email.errors?.required">Required</span>
									<span *ngIf="f.email.errors?.pattern">Invalid email format</span>
									<span *ngIf="f.email.errors?.incorrect">{{ customError.email }}</span>
								</div>
							</div>
							<div class="col-md-4 col-sm-12">
								<ng-select class="custom-ng-select" [ngClass]="{'is-invalid': showError('nationality')}"
									[items]="countryList" bindLabel="nationality" bindValue="id" [clearable]="true"
									placeholder="Nationality" formControlName="nationality" appearance="outline">
								</ng-select>
								<div *ngIf="showError('nationality')" class="invalid-feedback d-block">
									<span *ngIf="f.nationality.errors?.incorrect">{{ customError.nationality }}</span>
								</div>
							</div>
							<div class="col-md-3 col-sm-4">
								<ng-select class="custom-ng-select"
									[ngClass]="{'is-invalid': showError('country_code')}" [items]="countryCodes"
									bindLabel="display" bindValue="dial_code" [clearable]="true" [multiple]="false"
									id="country_code" formControlName="country_code" placeholder="Country Code*"
									appearance="outline">
								</ng-select>
								<div *ngIf="showError('country_code')" class="invalid-feedback d-block">
									<span *ngIf="f.country_code.errors?.required">Required</span>
									<span *ngIf="f.country_code.errors?.incorrect">{{ customError.country_code }}</span>
								</div>
							</div>
							<div class="col-md-5 col-sm-8">
								<div class="form-floating">
									<input class="form-control" [ngClass]="{'is-invalid': showError('tel_no')}"
										id="tel_no" formControlName="tel_no" placeholder="Phone No.">
									<label for="tel_no">Phone No.*</label>
								</div>
								<div *ngIf="showError('tel_no')" class="invalid-feedback d-block">
									<span *ngIf="f.tel_no.errors?.required">Required</span>
									<span *ngIf="f.tel_no.errors?.pattern">Invalid phone number</span>
									<span *ngIf="f.tel_no.errors?.incorrect">{{ customError.tel_no }}</span>
								</div>
							</div>
						</div>
					</div>
					<div class="form-section mb-4">
						<h6 class="text-uppercase fs-7 fw-bold text-muted mb-3 border-bottom pb-2">
							Crew & Assignment Details
						</h6>
						<div class="row g-3">
							<div class="col-md-3 col-sm-6">
								<div class="form-floating">
									<input class="form-control" [ngClass]="{'is-invalid': showError('crew_id')}"
										id="crew_id" formControlName="crew_id" placeholder="Crew ID">
									<label for="crew_id">Crew ID</label>
								</div>
								<div *ngIf="showError('crew_id')" class="invalid-feedback d-block">
									<span *ngIf="f.crew_id.errors?.required">Required</span>
									<span *ngIf="f.crew_id.errors?.incorrect">{{ customError.crew_id }}</span>
								</div>
							</div>
							<div class="col-md-3 col-sm-6">
								<ng-select class="custom-ng-select" [ngClass]="{'is-invalid': showError('company')}"
									[items]="companyList" bindLabel="com_name" bindValue="id" [clearable]="true"
									[multiple]="false" id="company" formControlName="company" placeholder="Company*"
									appearance="outline" (change)="getVessel()">
								</ng-select>
								<div *ngIf="showError('company')" class="invalid-feedback d-block">
									<span *ngIf="f.company.errors?.required">Required</span>
									<span *ngIf="f.company.errors?.incorrect">{{ customError.company }}</span>
								</div>
							</div>
							<div class="col-md-3 col-sm-6">
								<ng-select class="custom-ng-select" [ngClass]="{'is-invalid': showError('vessel')}"
									[items]="vesselList" bindLabel="vessel_name" bindValue="id" [clearable]="true"
									[multiple]="false" id="vessel" formControlName="vessel" placeholder="Vessel*"
									appearance="outline">
								</ng-select>
								<div *ngIf="showError('vessel')" class="invalid-feedback d-block">
									<span *ngIf="f.vessel.errors?.required">Required</span>
									<span *ngIf="f.vessel.errors?.incorrect">{{ customError.vessel }}</span>
								</div>
							</div>
							<div class="col-md-3 col-sm-6">
								<ng-select class="custom-ng-select" [ngClass]="{'is-invalid': showError('rank')}"
									[items]="rankList" bindLabel="rank" bindValue="rank_id" [clearable]="true"
									[multiple]="false" id="rank" formControlName="rank" placeholder="Rank"
									appearance="outline">
								</ng-select>
								<div *ngIf="showError('rank')" class="invalid-feedback d-block">
									<span *ngIf="f.rank.errors?.required">Required</span>
									<span *ngIf="f.rank.errors?.incorrect">{{ customError.rank }}</span>
								</div>
							</div>
						</div>
						<div class="row mt-3">
							<div class="col-12">
								<div class="form-check p-0">
									<mat-checkbox color="primary" formControlName="upcoming_arrival"
										id="upcoming_arrival">
										<span class="fw-medium text-dark">Upcoming Arrival</span>
									</mat-checkbox>
								</div>
							</div>
						</div>
					</div>
					<div class="d-flex justify-content-end gap-2 pt-3 border-top">
						<button type="button" class="btn btn-light px-4" (click)="clearForm()">Cancel</button>
						<button type="submit" class="btn btn-primary px-4 d-flex align-items-center gap-2"
							[disabled]="showLoader || !modform.dirty">
							<fa-icon *ngIf="!showLoader" [icon]="['fas', 'save']"></fa-icon>
							<fa-icon *ngIf="showLoader" [icon]="['fas', 'spinner']" animation="spin"></fa-icon>
							Submit
						</button>
					</div>
				</form>
			</div>
		</div>
	</div>
</div>
}
<div class="modal fade" id="caseIdModal" role="dialog">
	<div class="modal-dialog modal-xl">
		<div class="modal-content">
			<div class="modal-header">
				<h4 class="modal-title mb-0">Fetch Case Details</h4>
				<button type="button" class="btn-close" (click)="closeCaseIdModal();"></button>
			</div>
			<div class="modal-body">
				<div class="row mb-2">
					<div class="col-lg-4 col-md-4 col-sm-10 col-xs-10">
						<input id="searchInput" placeholder="Search" [formControl]="searchControl"
							class="form-control" />
					</div>
					<div class="col-lg-2 col-md-2 col-sm-2 col-xs-2">
						<fa-icon *ngIf="fetchCaseIdDetailsLoader" [icon]="['fas', 'spinner']" animation="spin"
							[size]="'2x'"></fa-icon>
					</div>
				</div>
				<ng-container *ngIf="detailsFromCaseId">
					<div class="row mb-2">
						<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
							<table class="table table-bordered">
								<tbody>
									<tr>
										<th>3C Id</th>
										<td>{{detailsFromCaseId?.cc_id}}</td>
										<th>Candidate Name</th>
										<td>{{detailsFromCaseId?.f_name}} {{detailsFromCaseId?.l_name}}</td>
									</tr>
									<tr>
										<th>Gender</th>
										<td>{{detailsFromCaseId?.gender}}</td>
										<th>D.O.B.</th>
										<td>{{detailsFromCaseId?.dob}}</td>
									</tr>
									<tr>
										<th>Email</th>
										<td>{{detailsFromCaseId?.email}}</td>
										<th>Nationality</th>
										<td>{{detailsFromCaseId?.nationality}}</td>
									</tr>
									<tr>
										<th>Company</th>
										<td>{{detailsFromCaseId?.company}}</td>
										<th>Vessel</th>
										<td>{{detailsFromCaseId?.vessel}}</td>
									</tr>
									<tr>
										<th>Rank</th>
										<td>{{detailsFromCaseId?.rank}}</td>
										<th>Crew Id</th>
										<td>{{detailsFromCaseId?.crew_id}}</td>
									</tr>
									<tr>
										<th>Sign-off By</th>
										<td>{{detailsFromCaseId?.signoff_by}}</td>
										<th>Sign-off Date</th>
										<td>{{detailsFromCaseId?.signoff_date}}</td>
									</tr>
									<tr>
										<th>Reported As</th>
										<td>{{detailsFromCaseId?.reported_as}}</td>
										<th>Assigned Doctor RMA</th>
										<td>{{detailsFromCaseId?.dr_name}}</td>
									</tr>
									<tr>
										<th>Port Visit</th>
										<td>{{detailsFromCaseId?.port_visit}}</td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>
					<div class="row mb-1">
						<div class="col">
							<h4><span class="text-decoration-underline">Initial Diagnosis</span></h4>
							<div [innerHTML]="detailsFromCaseId?.initialDiagnosis || '' |safeHtml"></div>
						</div>
						<div class="col">
							<h4><span class="text-decoration-underline">Medical Summary</span></h4>
							<div [innerHTML]="detailsFromCaseId?.medical_summary || '' |safeHtml"></div>
						</div>
					</div>
					<div class="row mb-1">
						<div class="col">
							<h4><span class="text-decoration-underline">Symptoms</span></h4>
							<div *ngIf="detailsFromCaseId?.symptoms.length">
								<span *ngFor="let sysd of detailsFromCaseId?.symptoms;last as isLast;">
									{{sysd}}
									{{isLast ? '' : ', '}}
								</span>
							</div>
							<div *ngIf="!detailsFromCaseId?.symptoms.length">
								-----
							</div>
						</div>
						<div class="col">
							<h4><span class="text-decoration-underline">Sub-Symptoms</span></h4>
							<div *ngIf="detailsFromCaseId?.subsymptoms.length">
								<span *ngFor="let sysd of detailsFromCaseId?.subsymptoms;last as isLast;">
									{{sysd}}
									{{isLast ? '' : ', '}}
								</span>
							</div>
							<div *ngIf="!detailsFromCaseId?.subsymptoms.length">
								-----
							</div>
						</div>
					</div>
					<div class="row mb-1">
						<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
							<h4><span class="text-decoration-underline">Medicines</span></h4>
							<table class="table table-striped table-bordered"
								*ngIf="detailsFromCaseId?.medicines.length > 0" id="medicineTable">
								<thead>
									<tr>
										<th>Date</th>
										<th>Name</th>
										<th>Dosage</th>
										<th>Frequency</th>
										<th>Meals</th>
										<th>No. Of Days</th>
										<th>Status</th>
										<th>Notes</th>
									</tr>
								</thead>
								<tbody>
									<tr *ngFor="let field of detailsFromCaseId?.medicines; let i = index">
										<td>
											{{field.medDate }}
										</td>
										<td>
											{{field.name}}
										</td>
										<td>
											{{field.qty}}
										</td>
										<td>
											{{getFrequencyText(field)}}
										</td>
										<td>
											{{field.meals}}
										</td>
										<td>
											{{field.noOfDays}}
										</td>
										<td>
											{{field.status}}
										</td>
										<td>
											{{field.notes}}
										</td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>
				</ng-container>
			</div>
			<div class="modal-footer">
				<button type="button" class="btn btn-success btn-sm" (click)="useCaseDetails();">
					Use Details
				</button>
				<button type="button" class="btn btn-warning btn-sm" (click)="closeCaseIdModal();">
					Cancel
				</button>
			</div>
		</div>
	</div>
</div>
<div *ngIf="navbar.userAccess?.Appointments!='Full'">
	<h3 class="text-center">You don't have access to this section.</h3>
</div>